// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { StyledButton } from "@insite/mobius/Clickable";
import { getProp } from "@insite/mobius/utilities";
import { contentBlockStyles, DEFAULT_CONTENT_BLOCK_WIDTH } from "@west/App/Components/Menu/ContentBlock";
import { color } from "@west/XDL/Utilities";
import { css } from "styled-components";

contentBlockStyles.container = {
    css: css`
        display: flex;
        flex-direction: column;
        padding: 16px 14px;
        gap: 13px;
        width: 100%;
        max-width: ${DEFAULT_CONTENT_BLOCK_WIDTH}px;
        flex-shrink: 0;
        background: ${color("common.white")};
        border-style: solid;
        border-color: ${color("common.border")};
        border-width: 0 0 0 1px;

        height: 450px;
        max-height: calc(100vh - 280px);

        position: relative;
        left: ${({ shift }: any) => shift - 1}px;
        top: 0;
        transition: all ${getProp("theme.transition.duration.regular")}ms ease-in-out;

        /* tippy has a higher z-index which is why contentBlock image/url becomes unclickable when  
        its displayed besides L2 Categories
     */
        z-index: 9999;

        /* when contentBlockImage has url and is clickable */
        ${StyledButton} {
            align-items: baseline;
            &:focus {
                outline: none;
            }
        }
    `,
};

contentBlockStyles.link = {
    css: css`
        max-height: 359px;
        max-width: 336px;
        width: auto;
        height: auto;
        object-fit: cover;
        border-radius: 2px;
        overflow: hidden;
    `,
};

contentBlockStyles.image = {
    css: css`
        max-height: 100%;
        max-width: 100%;
        width: 100%;
        height: auto;
        object-fit: cover;
        border-radius: 2px;
    `,
};
